export default __webpack_public_path__ + "static/media/bgHead.c0d7a677.png";